<app-navbar></app-navbar>

<ng-container *ngIf="wentWrong; else successBlock">
  <div class="page">
    <div class="confirmation-container">
      <mat-icon
        [class.text-danger]="!alreadyVerified"
        [class.text-warning]="alreadyVerified"
        class="icon-large">
        {{ alreadyVerified ? 'warning' : 'error_outline' }}
      </mat-icon>
      <h2>{{ errorMessage | translate }}</h2>
      <p *ngIf="alreadyVerified">{{ 'Your review has already been verified.' | translate }}</p>
      <p *ngIf="!alreadyVerified">{{ 'Something went wrong. The verification link may be invalid or expired.' | translate }}</p>
      <button class="dashboard-btn" (click)="toDashboard()">{{ 'Return to Home' | translate }}</button>
    </div>
  </div>
</ng-container>

<ng-template #successBlock>
  <div class="page">
    <div class="confirmation-container">
      <mat-icon class="color-primary icon-large">check_circle_outline</mat-icon>
      <h2>{{ 'Review Verified!' | translate }}</h2>
      <p>{{ 'Thank you! Your review has been successfully verified and will be published shortly.' | translate }}</p>
      <button class="dashboard-btn" (click)="toDashboard()">{{ 'Return to Home' | translate }}</button>
    </div>
  </div>
</ng-template>

